import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?keyword=${encodeURIComponent(kw)}`);
    setMenuOpen(false);
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-950/95 backdrop-blur-sm border-b border-primary-900">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
              <i className="ri-movie-2-fill text-xl"></i>
            </span>
            <span className="text-lg md:text-xl font-heading font-bold text-background-50 tracking-wide whitespace-nowrap">
              欲望之岛
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? "text-accent-400 bg-primary-900"
                    : "text-background-200 hover:text-background-50 hover:bg-primary-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <form
            onSubmit={submitSearch}
            className="hidden md:flex items-center bg-primary-900 rounded-md overflow-hidden w-56 lg:w-72 focus-within:ring-2 focus-within:ring-accent-500/60"
          >
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 资讯"
              className="flex-1 bg-transparent px-3 py-2 text-sm text-background-50 placeholder:text-background-400 focus:outline-none"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="px-3 py-2 text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </form>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-background-50 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-primary-950 border-t border-primary-900 px-4 pb-4">
          <form
            onSubmit={submitSearch}
            className="flex items-center bg-primary-900 rounded-md overflow-hidden mt-3 focus-within:ring-2 focus-within:ring-accent-500/60"
          >
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 资讯"
              className="flex-1 bg-transparent px-3 py-2.5 text-sm text-background-50 placeholder:text-background-400 focus:outline-none"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="px-3 py-2.5 text-background-300 cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </form>
          <nav className="flex flex-col mt-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className={`px-3 py-3 rounded-md text-sm font-label cursor-pointer ${
                  isActive(link.to)
                    ? "text-accent-400 bg-primary-900"
                    : "text-background-200 hover:bg-primary-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}